export function getMaximumScale(params)
{
    const heightRatio = params.fit.height / params.source.height

    if ((params.source.width * heightRatio) > params.fit.width)
    {
        return {
            w: params.source.width * heightRatio + (params.source.width * heightRatio / 100 * 1),
            h: params.source.height * heightRatio + (params.source.height * heightRatio / 100 * 1),
            fit: true
        }
    }

    const widthRatio = params.fit.width / params.source.width

    return {
        w: params.source.width * widthRatio + (params.source.width * widthRatio / 100 * 1),
        h: params.source.height * widthRatio + (params.source.height * widthRatio / 100 * 1),
        fit: false
    }
}

export function clamp(n, min = 0, max = 1)
{
    if (min > max)
    {
        const tmp = max
        max = min
        min = tmp
    }

    return Math.min(Math.max(n, min), max)
}

export function clampMin(n, min = 0)
{
    return Math.max(n, min)
}

export function clampMax(n, max = 1)
{
    return Math.min(n, max)
}



// WEBPACK FOOTER //
// ./src/scripts/utils/Maths.js